import React from 'react';
import Accordion from "../../../components/Accordion";
import TalentAssessmentModal from "./TalentAssessmentModal";

export default class TalentHRAssessmentModal extends TalentAssessmentModal {

    static type = 'hr';
    /**
     * The fields mapping for the form
     */
    formFields() {
        let {
            talent
        } = this.state;

        let hrAssessment = talent.managerInterview().hrAssessment();
        let formFields = [];

        for (let [name, scoreItem] of Object.entries(hrAssessment.scores)) {
            let sectionKey = TB.keys(hrAssessment.scores).indexOf(name) + 1;
            formFields.push({
                    fields: {
                        [name + "_info"]: (
                            <div className="assessment-section md:w-10/12 self-center">
                                <Accordion opened={false} header={open => (
                                    <h4>Section {sectionKey}: {scoreItem.label}</h4>
                                )}>
                                    <div className="section-instructions">
                                        <div>
                                            <h5 className="text-bold">
                                                What {laravel.platform_name} is looking for
                                            </h5>
                                            <ul>
                                                {scoreItem.requirements.length > 0 && scoreItem.requirements.map((requirement, i) => (
                                                    <li key={TB.slugify(scoreItem.label + 'requirement') + '-' + i}>
                                                        {requirement}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div>
                                            <h5 className="text-bold">
                                                Questions
                                            </h5>
                                            <ul>
                                                {scoreItem.questions.length > 0 && scoreItem.questions.map((question, i) => (
                                                    <li key={TB.slugify(scoreItem.label + 'question') + '-' + i}>
                                                        {question}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </Accordion>



                            </div>
                        )
                    }
                }, {
                    fields: {
                        [name + "_score"]: {
                            label: 'Score',
                            placeholder: '',
                            type: 'rating',
                            required: false,
                            style: styles.field,
                            columns: 10
                        }
                    }
                },
                {
                    fields: {
                        [name + "_score_notes"]: {
                            label: "Notes",
                            placeholder: "Notes",
                            type: 'textarea',
                            required: false,
                            style: styles.field,
                            maxLength: 2000,
                            columns: 10,
                            rows: 4
                        }
                    }
                },
                {
                    fields: {
                        spacer: (
                            <div className="assessment-spacer">
                                <hr/>
                            </div>
                        )
                    }
                })
        }

        formFields.push({
            style: styles.fieldSection,
            fields: {
                hr_notes: {
                    label: "HR Notes",
                    placeholder: "Any additional notes?",
                    type: 'textarea',
                    required: false,
                    style: styles.field,
                    maxLength: 2000,
                    columns: 10,
                    rows: 6
                },
            }
        },)
        return formFields;
    };

    renderAssessmentScore() {
        let {
            talent,
            isEditing
        } = this.state;

        let interview = talent.managerInterview();
        let hrAssessment = interview.hrAssessment();
        return (
            <div className="assessment-scoring">
                <div className="assessment-score-row">
                    <div className="assessment-score-section">
                        <div className="score-label status">
                            <p className="mb-0">
                                Status
                            </p>
                        </div>
                        <div className={TB.mapClass("score-value status", {
                            approved: interview.hrWasApproved(),
                            rejected: !interview.hrWasApproved() && interview.hrWasRejected(),
                            incomplete: !interview.hasHRStatus(),
                        })}>
                            <p className="text-bold mb-0">
                                {interview.hrStatusDisplay()}
                            </p>
                        </div>
                    </div>
                    {interview.hasHRStatus() ? (
                        <div className="assessment-score-section">
                            <div className="score-label overall border-top-0">
                                <p className="mb-0">
                                    {interview.hrWasApproved() ? 'Approved By' : 'Rejected By'}

                                </p>
                            </div>
                            <div className="score-value overall border-top-0">
                                <p className="text-bold mb-0">
                                    {interview.hrInterviewedBy()}
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div className="assessment-spacer"/>
                    )}
                    <div className="assessment-score-section">
                        <div className="score-label overall border-top-0">
                            <p className="mb-0">
                                Overall Score
                            </p>
                        </div>
                        <div className="score-value overall border-top-0">
                            <p className="text-bold mb-0">
                                {interview.hrOverallScore() || 'N/A'}
                            </p>
                        </div>
                    </div>
                    {interview.hasHRStatus() ? (
                        <div className="assessment-score-section">
                            <div className="score-label status">
                                <p className="mb-0">
                                    {interview.hrWasApproved() ? 'Approved At' : 'Rejected At'}
                                </p>
                            </div>
                            <div className="score-value overall border-top-0">
                                {TB.moment((interview.hrWasApproved() ? interview.hr_approved_at : interview.hr_rejected_at) || 'now').format('ll')}
                            </div>
                        </div>
                    ) : (
                        <div className="assessment-spacer"/>
                    )}
                </div>

                <div className="assessment-score-row">
                    {TB.map(TB.values(hrAssessment.scores), (score, i) => (
                        <div className="assessment-score-section" key={TB.slugify(score.label) + '-section'}>
                            <div className={TB.mapClass("score-label", {
                                "border-top-0": i >= 2
                            })}>
                                <p className="mb-0">
                                    {score.name}
                                </p>
                            </div>
                            <div className={TB.mapClass("score-value", {
                                "border-top-0": i >= 2
                            })}>
                                <p className="text-bold mb-0">{score.score || 'N/A'}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }

}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
    fieldHidden: {
        height: 0,
        width: 0,
        zIndex: -10,
        opacity: 0,
        position: 'absolute',
        left: -9999
    }
};